import { getCookie } from '@client/helpers/cookie';
import { get } from '@client/lib/request';
import { PERSONALIZED_CAMPAIGNS_FIELDS } from '@shared/constants';
import { MyLoungeResponse } from '@shared/types/mylounge';

const getUpcomingLimit = (): number | null => {
    const EXTENDED_UPCOMING_COOKIES = 'zl_extended_upcoming';

    return getCookie(EXTENDED_UPCOMING_COOKIES) === 'true' ? 200 : null;
};

export const getCampaigns = (
    onlineAt: string,
    { requestedLoyaltyAccess }: { requestedLoyaltyAccess?: string } = {},
): Promise<MyLoungeResponse | null> => {
    return get(
        '/api/phoenix/mylounge/campaigns',
        {
            online_at: onlineAt,
            upcoming_limit: getUpcomingLimit(),
            /**
             * @deprecated We will remove this in the future.
             * Use `requested_loyalty_access` instead.
             */
            include_exclusive: !!requestedLoyaltyAccess,
            ...(requestedLoyaltyAccess && { requested_loyalty_access: requestedLoyaltyAccess }),
        },
        null,
        true,
    );
};

export const getPersonalizedCampaigns = ({
    allowEligiblePlusAccess,
    requestedLoyaltyAccess,
}: {
    allowEligiblePlusAccess?: boolean;
    requestedLoyaltyAccess?: string;
} = {}): Promise<MyLoungeResponse | null> => {
    return get(
        '/api/phoenix/mylounge/personalized-campaigns',
        {
            fields: PERSONALIZED_CAMPAIGNS_FIELDS,
            upcoming_limit: getUpcomingLimit(),
            plus_early_access_supported: true,
            allow_eligible_plus_access: allowEligiblePlusAccess,
            /**
             * @deprecated We will remove this in the future.
             * Use `requested_loyalty_access` instead.
             */
            include_exclusive: !!requestedLoyaltyAccess,
            ...(requestedLoyaltyAccess && { requested_loyalty_access: requestedLoyaltyAccess }),
        },
        null,
        true,
    );
};
